import { NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";
import { HomepageComponent } from "./homepage/homepage.component";
import {CarouselsResolver} from "./services/carousels.resolver";
import {NewsItemsResolver} from "../news/services/news-items.resolver";

const routes: Routes = [
    {
        path: '',
        component: HomepageComponent,
        resolve: {
            carouselsResult: CarouselsResolver,
            newsItemsResult: NewsItemsResolver,
        },
    },
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule],
})
export class HomeRoutingModule {}
